import { css } from '@emotion/react'
import { PHONES } from 'styles/media-queries'

// Modal styles for react-modal (inline styles don't support media queries)
export const modalStyles = {
  content: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: 'none',
    borderRadius: 0,
    padding: 0,
    backgroundColor: '#1a1a1a',
    zIndex: 9999,
    width: '100%',
    height: '100%',
    margin: 0,
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    zIndex: 9998,
  },
}

export const modalContainer = css`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #1a1a1a;
  color: #ffffff;

  ${PHONES} {
    display: flex;
  }

  /* Hide on desktop - this modal should only show on mobile */
  @media (min-width: 768px) {
    display: none;
  }
`

export const header = css`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background-color: #2d2d2d;
  position: relative;
`

export const backButton = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 5px;
`

export const headerTitle = css`
  flex: 1;
  text-align: center;
  margin-right: 42px; // Compensate for back button width
`

export const eventSection = css`
  background-color: #2d2d2d;
  margin: 16px;
  border-radius: 12px;
  padding: 16px;
`

export const teamsContainer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const teamContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const teamLogo = css`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const logoImage = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const logoPlaceholder = css`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const teamName = css`
  color: #ffffff;
  text-align: center;
`

export const verticalSeparator = css`
  width: 1px;
  height: 60px;
  background-color: #555;
  margin: 0 20px;
`

export const dateTimeContainer = css`
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const timezone = css`
  color: #999;
`

export const date = css`
  color: #ffffff;
`

export const time = css`
  color: #ffffff;
`

export const balanceSection = css`
  margin: 0 16px 20px 16px;
`

export const balanceContainer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #2d2d2d;
  padding: 16px;
  border-radius: 12px;
`

export const balanceLabel = css`
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
`

export const cardIcon = css`
  color: #ffffff;
  flex-shrink: 0;
  display: block;

  /* Ensure crisp rendering */
  shape-rendering: crispEdges;

  /* Perfect alignment */
  margin-top: 1px;
`

export const balanceAmount = css`
  color: #ffffff;
  font-weight: 600;
`

export const dashedSeparator = css`
  width: calc(100% - 32px);
  margin: 4px 16px 16px 16px;
  border-top: 1px dashed #555;
`

export const dashedSeparatorInForm = css`
  width: 100%;
  margin: 4px 0 16px 0;
  border-top: 1px dashed #555;
`

export const dashedSeparatorInFormSmallTop = css`
  width: 100%;
  margin: -6px 0 16px 0;
  border-top: 1px dashed #555;
`

export const formContainer = css`
  flex: 1;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
`

export const fieldSection = css`
  margin-bottom: 24px;
`

export const fieldLabel = css`
  color: #ffffff;
  margin-bottom: 8px;
  display: block;
`

export const fieldSubtext = css`
  color: #999;
  margin-bottom: 12px;
  display: block;
`

export const simpleDropdown = css`
  position: relative;
`

export const selectInput = css`
  background-color: #2d2d2d !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  color: #999 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  width: 100% !important;
  min-height: 48px !important;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='%23999' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='m4 6 4 4 4-4'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;

  &:focus {
    border: none !important;
    outline: none !important;
  }

  option {
    background-color: #2d2d2d;
    color: #ffffff;
    font-size: 14px;
    font-weight: normal;
  }

  /* Style for the first option (placeholder) */
  option:first-child {
    color: #999;
    font-weight: 500;
  }
`

export const amountInput = css`
  background-color: #2d2d2d !important;
  border: 1px solid #444 !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  color: #ffffff !important;
  font-size: 16px !important;
  width: 100% !important;
  min-height: 48px !important;

  &::placeholder {
    color: #999 !important;
  }

  &:focus {
    border-color: #6b73ff !important;
    outline: none !important;
  }
`

export const amountFieldContainer = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #2d2d2d !important;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 8px;
  position: relative;
  cursor: pointer;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  min-height: 56px;
  max-height: 56px;
  height: 56px;
  box-sizing: border-box;

  &:focus-within {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background-color: #2d2d2d !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    min-height: 56px;
    max-height: 56px;
    height: 56px;
  }

  &:focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background-color: #2d2d2d !important;
  }

  &:hover {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background-color: #2d2d2d !important;
  }

  &:active {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background-color: #2d2d2d !important;
  }

  /* Override any global form input styles */
  input {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }
`

export const amountDisplay = css`
  flex: 1;
  pointer-events: none;
  height: 24px;
  display: flex;
  align-items: center;
`

export const amountInputContainer = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`

export const visibleNumberInput = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent !important;
  border: none !important;
  color: #ffffff !important;
  font-size: 14px;
  font-weight: 500;
  padding: 16px;
  outline: none !important;
  box-shadow: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  box-sizing: border-box;
  z-index: 2;

  &::placeholder {
    color: #999 !important;
  }

  &:focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
  }

  &:active {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  &:hover {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  /* Remove number input spinners */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`

export const formattedAmountDisplay = css`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  z-index: 1;
  pointer-events: none;
`

export const amountPlaceholder = css`
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: #999;
  font-weight: 500;
  z-index: 1;
  pointer-events: none;
`

export const amountValue = css`
  color: #ffffff;
  font-weight: 500;
`

export const hiddenAmountInput = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent !important;
  border: none !important;
  color: transparent !important;
  font-size: 14px;
  font-weight: 500;
  padding: 16px;
  outline: none !important;
  box-shadow: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  box-sizing: border-box;

  &:focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    color: transparent !important;
  }

  &:active {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    color: transparent !important;
  }

  &:hover {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    color: transparent !important;
  }

  /* Remove all webkit focus rings */
  &::-webkit-focus-ring-color {
    outline-color: transparent !important;
  }

  /* Remove number input spinners */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`

export const visibleAmountInput = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent !important;
  border: none !important;
  color: #ffffff !important;
  font-size: 14px;
  font-weight: 500;
  padding: 16px;
  outline: none !important;
  box-shadow: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  box-sizing: border-box;

  &::placeholder {
    color: #999 !important;
  }

  &:focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
  }

  &:active {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  &:hover {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  /* Remove number input spinners */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`

export const sponsorLimitSection = css`
  margin-bottom: 24px;
  margin-top: -30px;
  position: relative;
  display: flex;
  justify-content: flex-end;
`

export const sponsorLimitText = css`
  color: #999;
  font-size: 12px;
`

export const totalSection = css`
  margin-bottom: 24px;
`

export const totalContainer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #2d2d2d;
  padding: 16px;
  border-radius: 12px;
`

export const totalLabelContainer = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const totalLabelIcon = css`
  width: auto;
  height: 16px;
`

export const totalLabel = css`
  color: #ffffff;
`

export const totalAmount = css`
  color: #ffffff;
  font-weight: bold;
`

export const buttonSection = css`
  margin-top: auto;
  padding-bottom: 24px;
`

export const confirmButton = css`
  width: 100% !important;
  background: #6db66d !important;
  background-color: #6db66d !important;
  border: none !important;
  border-radius: 28px !important;
  padding: 18px !important;
  min-height: 60px !important;
  font-size: 16px !important;
  font-weight: bold !important;
  cursor: pointer !important;
  box-shadow: none !important;
  color: #000000 !important;

  * {
    color: #000000 !important;
  }

  &:hover {
    background: #7bc07b !important;
    background-color: #7bc07b !important;
  }

  &:hover * {
    color: #000000 !important;
  }

  &:disabled {
    background: #2d5a2d !important;
    background-color: #2d5a2d !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
  }

  &:disabled * {
    color: #000000 !important;
  }
`

export const customDropdownContainer = css`
  position: relative;
  width: 100%;
`

export const customDropdownTrigger = css`
  background-color: #2d2d2d !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  color: #999 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  width: 100% !important;
  min-height: 48px !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  &:focus {
    outline: none !important;
  }
`

export const selectedBeneficiaryDisplay = css`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`

export const beneficiaryLogo = css`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`

export const beneficiaryName = css`
  color: #ffffff !important;
  font-weight: 500;
`

export const placeholderText = css`
  color: #999 !important;
  font-weight: 500;
`

export const dropdownArrow = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`

export const arrowIcon = css`
  width: 12px;
  height: 12px;
`

export const customDropdownOptions = css`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #2d2d2d;
  border-radius: 8px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`

export const customDropdownOption = css`
  padding: 0;
  display: block;
  border-bottom: 1px solid #404040;

  &:last-child {
    border-bottom: none;
  }

  & > button {
    width: 100%;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    background: transparent;
    border: none;
    color: inherit;
    font: inherit;
    text-align: left;

    &:hover {
      background-color: #404040;
    }
  }
`

// Button reset styles for native button elements
// These reset default browser button styles while preserving functionality
export const accessibleButton = css`
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-align: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid #6b73ff;
    outline-offset: 2px;
  }
`

export const confirmationOverlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`

export const confirmationModal = css`
  background-color: #2d2d2d;
  border-radius: 12px;
  padding: 16px;
  margin: 20px;
  max-width: 280px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
`

export const confirmationHeader = css`
  text-align: center;
  margin-bottom: 16px;
`

export const confirmationTitle = css`
  color: #ffffff;
`

export const confirmationContent = css`
  margin-bottom: 20px;
`

export const confirmationRow = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const confirmationLabel = css`
  color: #999;
  font-weight: 500;
`

export const confirmationValue = css`
  color: #ffffff;
  font-weight: 500;
  text-align: right;
`

export const confirmationActions = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`

export const confirmationButton = css`
  width: 100%;
  background: #6db66d !important;
  background-color: #6db66d !important;
  border: none;
  border-radius: 20px;
  padding: 12px;
  min-height: 44px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: none;

  &:hover {
    background: #5fa65f !important;
    background-color: #5fa65f !important;
  }
`

export const confirmationButtonText = css`
  color: #000000;
`

export const changeDetailsText = css`
  color: #ffffff;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #cccccc;
  }
`

export const errorModal = css`
  background-color: #2d2d2d;
  border-radius: 16px;
  padding: 24px;
  margin: 20px;
  max-width: 350px;
  width: 100%;
  text-align: center;
`

export const errorHeader = css`
  margin-bottom: 16px;
`

export const errorTitle = css`
  color: #ffffff;
`

export const errorContent = css`
  margin-bottom: 24px;
`

export const errorMessage = css`
  color: #cccccc;
  line-height: 1.4;
`

export const errorActions = css`
  display: flex;
  justify-content: center;
`

export const errorButton = css`
  background: #6db66d !important;
  background-color: #6db66d !important;
  border: none;
  border-radius: 28px;
  padding: 14px 32px;
  min-height: 50px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: none;

  &:hover {
    background: #5fa65f !important;
    background-color: #5fa65f !important;
  }
`

export const errorButtonText = css`
  color: #000000;
`

export const topErrorMessage = css`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      transform: translate(-50%, -100%);
      opacity: 0;
    }
    to {
      transform: translate(-50%, 0);
      opacity: 1;
    }
  }
`

export const topErrorContent = css`
  background-color: #d32f2f;
  color: white;
  padding: 12px 20px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`

export const topErrorIcon = css`
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`

export const topErrorText = css`
  color: white;
  font-weight: 500;
`

export const successModal = css`
  background-color: #2d2d2d;
  border-radius: 16px;
  padding: 24px;
  margin: 20px;
  max-width: 350px;
  width: 100%;
  text-align: center;
`

export const successHeader = css`
  margin-bottom: 16px;
`

export const successTitle = css`
  color: #ffffff;
`

export const successContent = css`
  margin-bottom: 24px;
`

export const successMessage = css`
  color: #cccccc;
  line-height: 1.4;
`

export const successActions = css`
  display: flex;
  justify-content: center;
`

export const successButton = css`
  background: #6db66d !important;
  background-color: #6db66d !important;
  border: none;
  border-radius: 28px;
  padding: 14px 32px;
  min-height: 50px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: none;

  &:hover {
    background: #5fa65f !important;
    background-color: #5fa65f !important;
  }
`

export const successButtonText = css`
  color: #000000;
`

export const topSuccessMessage = css`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      transform: translate(-50%, -100%);
      opacity: 0;
    }
    to {
      transform: translate(-50%, 0);
      opacity: 1;
    }
  }
`

export const topSuccessContent = css`
  background-color: #4caf50;
  color: white;
  padding: 12px 20px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`

export const topSuccessIcon = css`
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`

export const topSuccessText = css`
  color: white;
  font-weight: 500;
`
